import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['row', 'emailLabel', 'emailField', 'addButton']
  static values = { totalLoanTypes: Number }

  connect() {
    this.updateDisabledOptions()
    this.element.addEventListener('rails-nested-form:remove', () => this.updateDisabledOptions())
  }

  add() {
    this.updateDisabledOptions()
  }

  updateDisabledOptions() {
    const rows = this.rowTargets.filter(row => !row.querySelector("input[name$='[_destroy]'][value='1']"))
    const selectedValues = new Set()

    rows.forEach(row => {
      const select = row.querySelector('select')
      if (select && select.value) {
        selectedValues.add(select.value)
      }
    })

    rows.forEach(row => {
      const select = row.querySelector('select')
      if (!select) return

      Array.from(select.options).forEach(option => {
        if (!option.value) return
        option.disabled = option.value !== select.value && selectedValues.has(option.value)
      })
    })

    this.toggleAddButton(rows.length)
  }

  toggleAddButton(activeRowCount) {
    if (!this.hasAddButtonTarget) return
    this.addButtonTarget.classList.toggle('hidden', activeRowCount >= this.totalLoanTypesValue)
  }

  change(event) {
    this.updateDisabledOptions()
    this.updateEmailLabel(event)
  }

  updateEmailLabel(event) {
    const row = event.target.closest("[data-cc-overrides-target='row']")
    if (!row) return

    const select = row.querySelector('select')
    const label = row.querySelector("[data-cc-overrides-target='emailLabel']")
    const emailField = row.querySelector("[data-cc-overrides-target='emailField']")
    if (!select) return

    const wrapper = emailField?.firstElementChild
    if (select.value) {
      const selectedText = select.options[select.selectedIndex]?.text
      if (label) label.textContent = `Hub Email for ${selectedText}`
      if (wrapper) wrapper.classList.remove('invisible')
    } else {
      if (wrapper) wrapper.classList.add('invisible')
    }
  }
}
